import * as React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import type { TextReadMoreBlockClassNames, TextReadMoreTogglerProps } from './textReadMoreBlock.state'
import { NestedBlock } from '../../modernBlocks.state'
import { TextBlockNestedLayout } from '../nestedBlocks/textBlockNested.layout'
import { QuoteBlockNestedLayout } from '../nestedBlocks/quoteBlockNested.layout'
import { MediaBlockNestedLayout } from '../nestedBlocks/mediaBlockNested.layout'
import { LinkListBlockNestedLayout } from '../nestedBlocks/linkListBlockNested.layout'
import { VideoLayout } from '../mediaBlock/mediaVideo.layout'
import { State } from '../../../cmsPage.widget'
import { Updater } from 'widgets-for-react'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const textReadMoreBlockClasses: TextReadMoreBlockClassNames = {
  // DEFAULTS
  block: 'block block--text block--text-more',
  inview: 'inview',
  inner: 'block__inner ls-container ls-gutter ls-spacing--s',
  header: 'block__header',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content',
  text: 'block__text text--styled',

  // BLOCK SPECIFIC
  toggler: 'readmore',
  togglerButton: 'readmore__button button button--tertiary',
  togglerLabel: 'readmore__label button__label',
  togglerContent: 'readmore__content'
}

export const TextReadMoreLayout = {
  Inner: (props: { id?: string; children?: React.ReactNode }): JSX.Element => {
    const { children, id } = props
    return (
      <div className={getClassNameModern(textReadMoreBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>
        {children}
      </div>
    )
  },
  Content: (props: {
    label?: string
    title?: string
    intro?: string
    text: string
    nestedBlocks: NestedBlock[]
    toggler: TextReadMoreTogglerProps
    isOpen: boolean
    rootState: State
    setRootState: (_: Updater<State>) => void
  }) => {
    const {
      label,
      title,
      intro,
      text,
      nestedBlocks,
      toggler,
      isOpen,
      rootState,
      setRootState
    } = props
    return (
      <>
        {(label || title || intro) && (
          <header className={getClassNameModern(textReadMoreBlockClasses, 'header', '')}>
            {label && (
              <p className={getClassNameModern(textReadMoreBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>
                {label}
              </p>
            )}
            {title && <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(textReadMoreBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>}
            {intro && (
              <p
                className={getClassNameModern(textReadMoreBlockClasses, 'intro', 'text--styled mb-3')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            )}
          </header>
        )}
        {text && (
          <div className={getClassNameModern(textReadMoreBlockClasses, 'content', '')}>
            <div
              className={getClassNameModern(textReadMoreBlockClasses, 'text', 'text--styled')}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        )}

        <details className={getClassNameModern(textReadMoreBlockClasses, 'toggler', '')} open={isOpen}>
          <summary className={getClassNameModern(textReadMoreBlockClasses, 'togglerButton', 'btn btn-primary mt-5')}>
            <span
              className={getClassNameModern(
                textReadMoreBlockClasses,
                'togglerLabel',
                isOpen == true ? 'd-none' : ''
              )}
            >
              {toggler.openLabel}
            </span>
          </summary>

          <div className={getClassNameModern(textReadMoreBlockClasses, 'togglerContent', 'mt-5')}>
            {nestedBlocks.map((nb, n) =>
              nb.kind == 'textNested' ? (
                <TextBlockNestedLayout key={nb.index} {...nb} />
              ) : nb.kind == 'quoteNested' ? (
                <QuoteBlockNestedLayout key={nb.index} {...nb} />
              ) : nb.kind == 'mediaNested' ? (
                <MediaBlockNestedLayout key={`${nb.index}`} {...nb}
                  videoChild={
                    <VideoLayout
                      mediaBlock={{ ...nb, type: 'video', url: (nb.type == 'video' && nb.url) || '' }}
                      rootState={props.rootState}
                      setState={props.setRootState}
                    />
                  }
                />
              ) : nb.kind == 'linkListNested' ? (
                <LinkListBlockNestedLayout key={nb.index} {...nb} />
              ) : (
                <></>
              )
            )}
          </div>
        </details>
      </>
    )
  },
}
